import React, { Fragment, useEffect, useState } from 'react';
import { Add, Delete, Details, Edit } from '@mui/icons-material';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { routesName } from '../../constants/routes-name';
import { ApiManager } from '../../services/api';
import { Avatar, Collapse, IconButton, Tooltip } from '@mui/material';
import useNotification from '../../hooks/useNotification';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { ChatingComponent } from '../../components';
import BreadcrumbsWrapper from '../../components/BreadcrumbsWrapper';

function Component() {
  const { user, role } = useSelector(({ user }) => user);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tenderId = searchParams.get('tender');
  const srid = searchParams.get('srid');
  const { errorNonification, successNonification } = useNotification();
  const [chatHeads, setChatHeads] = useState([]);
  const [messages, setMessages] = useState([]);
  const [search, setSearch] = useState('');
  const [subChatOpenFor, setSubChatOpenFor] = useState();

  useEffect(() => {
    getChatHeads();

    const interval = setInterval(() => {
      getChatHeads();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const getChatHeads = async () => {
    const res = await ApiManager.getChatHeads();
    if (res?.status === 200 && res?.data?.result) {
      setChatHeads(res.data.result);
    }
  };

  const breadcrumbs = [
    { title: 'Dashboard', path: routesName.dashboard },
    { title: 'Messages' },
  ];

  return (
    <div>
      <BreadcrumbsWrapper breadcrumbs={breadcrumbs} />
      <div className="flex-1 flex flex-row justify-between bg-white h-[82vh] mt-3">
        {/*   <!-- chat list --> */}
        <div className="flex flex-col w-2/5 border-r-2 overflow-y-auto">
          {/*   <!-- search compt --> */}
          <div className="border-b-2 py-4 px-2">
            <input
              onChange={(e) => setSearch(e.target.value)}
              type="text"
              placeholder="search chatting"
              className="py-2 px-2 border-2 border-gray-200 rounded-2xl w-full"
            />
          </div>
          {/*  <!-- end search compt --> */}
          {/* <!-- user list --> */}
          {!search && Array.isArray(chatHeads) ? (
            chatHeads.map((head, item) => (
              <div>
                <div
                  key={head?.tender?._id}
                  onClick={() => {
                    /*  setSubChatOpenFor((id) =>
                      id === head?.tender?._id ? '' : head?.tender?._id
                    ); */
                    navigate(
                      `${routesName.unreadMessages}?tender=${head?.tender?._id}`
                    );
                  }}
                  className={`flex flex-row py-4 px-2 justify-center items-center border-b-2 cursor-pointer hover:bg-gray-200 ${
                    tenderId === head?.tender?._id ? 'bg-blue-100' : 'white'
                  }`}
                >
                  <div className="w-full">
                    <div className="text-lg font-semibold">
                      {head?.tender?.tenderTitle}
                    </div>
                    <span className="text-gray-500 text-xs text-ellipsis">
                      {head?.message}
                    </span>
                  </div>
                </div>
                {/*   <Collapse
                  in={subChatOpenFor === head?.tender?._id}
                  timeout="auto"
                >
                  {Array.isArray(head?.users) &&
                    head.users.map((item, index) => {
                      if (user?._id === item?._id) {
                        return <Fragment key={item?._id} />;
                      }
                      return (
                        <div
                          onClick={() => {
                            navigate(
                              `${routesName.unreadMessages}?tender=${head?.tender?._id}&srid=${item?._id}`
                            );
                          }}
                          key={item?._id}
                          className={`flex flex-row py-4 px-2 justify-center items-center border-b-2 cursor-pointer hover:bg-gray-200 ${
                            srid === item._id ? 'bg-blue-400' : 'white'
                          }`}
                        >
                          <div className="w-14">
                            <Avatar>{chatHeads?.tender?.tenderTitle}</Avatar>
                          </div>
                          <div className="w-full">
                            <div className="text-sm font-semibold">
                              {item?.name}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </Collapse> */}
              </div>
            ))
          ) : search && Array.isArray(chatHeads) ? (
            chatHeads
              .filter((item) =>
                `${item.tender.tenderTitle}`
                  .toLocaleLowerCase()
                  .includes(search.toLocaleLowerCase())
              )
              .map((head, item) => (
                <div
                  key={head?._id}
                  onClick={() =>
                    navigate(
                      `${routesName.unreadMessages}?tender=${head?.tender?._id}`
                    )
                  }
                  className="flex flex-row py-4 px-2 justify-center items-center border-b-2 cursor-pointer hover:bg-gray-200"
                >
                  <div className="w-1/4">
                    <Avatar>{chatHeads?.tender?.tenderTitle}</Avatar>
                  </div>
                  <div className="w-full">
                    <div className="text-lg font-semibold">
                      {head?.tender?.tenderTitle}
                    </div>
                    <span className="text-gray-500 text-xs text-ellipsis">
                      {head?.message}
                    </span>
                  </div>
                </div>
              ))
          ) : (
            <div></div>
          )}

          {/*  <!-- end user list --> */}
        </div>
        {/*  <!-- end chat list --> */}
        {/*   <!-- message --> */}
        <ChatingComponent />
      </div>
    </div>
  );
}

export default Component;
